// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay-con {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}

.cupller-title {
  font-family: "Leckerli One", cursive;
  font-size: 2rem;
  margin: 5px;
  color: var(--primary-text);
}

.modal-con {
  background-color: var(--bg-color);
  color: var(--bg-color);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  position: relative;
  max-width: 85%;
  width: 360px;
  overflow-y: auto;
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-content-con {
  color: var(--secondary-text);
}

.modal-content-con h2 {
  font-size: 1.5rem;
  color: var(--primary-text);
  cursor: default;
  font-weight: var(--nunito-bold);
  margin-top: 30px;
  margin-bottom: 30px;
  letter-spacing: 5px;
}

.modal-content-con p {
  text-align: center;
  margin: 20px 0px;
}

.modal-content-con span {
  font-weight: var(--nunito-black);
  font-size: 1.1rem;
}

.ok-btn {
  background-color: var(--primary-text);
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  font-weight: var(--nunito-bold);
  color: var(--bg-color);
  font-size: 20px;
  width: 40%;
  height: 50px;
  min-width: 70px;
  margin: 10px 0px;
  position: relative;
}

@media (hover: hover) {
  .ok-btn:hover {
    background-color: var(--secondary-text);
  }

  .light-theme .ok-btn:hover {
    background-color: var(--alt-color);
    color: var(--primary-text);
  }
}

@media screen and (max-width: 700px) {
  .cupller-title {
    font-size: 1.5rem;
  }

  .modal-con {
    max-height: 72%;
    max-width: 80%;
    padding: 20px 20px 10px 20px;
  }

  .modal-content-con h2 {
    font-size: 1rem;
    margin-top: 20px;
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/consent/Consent.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".modal-overlay-con {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.9);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cupller-title {\r\n  font-family: \"Leckerli One\", cursive;\r\n  font-size: 2rem;\r\n  margin: 5px;\r\n  color: var(--primary-text);\r\n}\r\n\r\n.modal-con {\r\n  background-color: var(--bg-color);\r\n  color: var(--bg-color);\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\r\n  position: relative;\r\n  max-width: 85%;\r\n  width: 360px;\r\n  overflow-y: auto;\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.modal-content-con {\r\n  color: var(--secondary-text);\r\n}\r\n\r\n.modal-content-con h2 {\r\n  font-size: 1.5rem;\r\n  color: var(--primary-text);\r\n  cursor: default;\r\n  font-weight: var(--nunito-bold);\r\n  margin-top: 30px;\r\n  margin-bottom: 30px;\r\n  letter-spacing: 5px;\r\n}\r\n\r\n.modal-content-con p {\r\n  text-align: center;\r\n  margin: 20px 0px;\r\n}\r\n\r\n.modal-content-con span {\r\n  font-weight: var(--nunito-black);\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.ok-btn {\r\n  background-color: var(--primary-text);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-weight: var(--nunito-bold);\r\n  color: var(--bg-color);\r\n  font-size: 20px;\r\n  width: 40%;\r\n  height: 50px;\r\n  min-width: 70px;\r\n  margin: 10px 0px;\r\n  position: relative;\r\n}\r\n\r\n@media (hover: hover) {\r\n  .ok-btn:hover {\r\n    background-color: var(--secondary-text);\r\n  }\r\n\r\n  .light-theme .ok-btn:hover {\r\n    background-color: var(--alt-color);\r\n    color: var(--primary-text);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n  .cupller-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .modal-con {\r\n    max-height: 72%;\r\n    max-width: 80%;\r\n    padding: 20px 20px 10px 20px;\r\n  }\r\n\r\n  .modal-content-con h2 {\r\n    font-size: 1rem;\r\n    margin-top: 20px;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
